import { useSpecialties } from '@services/hooks/useSpecialties';
import { authUserService } from '@store/AuthUser/services/authUserService';

interface Data {
    walkIn: boolean;
}

export function useIsWalkIn(): Data {
    const { getSpecialtyById } = useSpecialties();

    return {
        walkIn: authUserService.getAuthUserSpecialtyIds().some(id => !!getSpecialtyById(id)?.walkIn),
    };
}
